module.exports = __webpack_public_path__ + "img/__icon_BUS_CHŁODNIA.9c183d00.svg";